import * as ActionCreators from '../actions/ActionCreators';
import { actionEqual } from './utils';

const defaultState: ModalState = {
  modalType: null,
  info: null,
};

export default function modal(
  state: ModalState = defaultState,
  action: Action
): ModalState {
  const { payload } = action;
  if (actionEqual(action, ActionCreators.showModal)) {
    return {
      modalType: payload.modal,
      info: payload.info,
    };
  } else if (actionEqual(action, ActionCreators.closeModal)) {
    return {
      modalType: null,
      info: null,
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/modal.ts